import { render, staticRenderFns } from "./veStuAssocActivityShow.vue?vue&type=template&id=c4a13fa0&scoped=true"
import script from "./veStuAssocActivityShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a13fa0",
  null
  
)

export default component.exports